// extracted by css-extract-rspack-plugin
export default {"cardHeader":"cardHeader-hQ84Yq"};